import React from "react";
import {Card, Typography, Spin} from "antd";
import JSONInput from "react-json-editor-ajrm";
import moment from "moment";
import {isNumber} from "lodash";
import {ListItemContainer} from "./CourierWalletInvoiceDetail.styles";
const {Text} = Typography;

export const CourierWalletInvoiceDetail = ({paymentInvoice, loading}) => {
    if (loading) {
        return (
            <Card title={`${date ? moment(date).format("DD MMMM YYYY") : ""} Özeti`}>
                <div style={{textAlign: "center", padding: "20px"}}>
                    <Spin />
                </div>
            </Card>
        );
    }

    return (
        <Card title={`Fatura Detayı (${paymentInvoice?.invoiceId})`}>
            <ListItemContainer>
                <JSONInput
                    id="paymentInvoiceJSON"
                    placeholder={paymentInvoice}
                    theme="dark_mitsuketa_tribute"
                    width="auto"
                    height="auto"
                    viewOnly={true}
                    confirmGood={false}
                />
            </ListItemContainer>
        </Card>
    );
};
